import React, { useState, useEffect } from 'react';

// A helper function to flatten the category tree for the dropdown
const flattenCategories = (categories, prefix = '') => {
  let options = [];
  for (const category of categories) {
    options.push({
      id: category.id,
      name: `${prefix}${category.english_name}`
    });
    if (category.sub_classifications && category.sub_classifications.length > 0) {
      options = options.concat(flattenCategories(category.sub_classifications, `${prefix}- `));
    }
  }
  return options;
};


export default function CategoryModal({ isOpen, onClose, onSave, initialData = null, categories = [] }) {
  const [englishName, setEnglishName] = useState('');
  const [arabicName, setArabicName] = useState('');
  const [parentId, setParentId] = useState('');

  // This effect pre-fills the form when the modal opens in "Edit" mode.
  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setEnglishName(initialData.english_name || '');
        setArabicName(initialData.arabic_name || '');
        setParentId(initialData.parent_id || '');
      } else {
        setEnglishName('');
        setArabicName('');
        setParentId('');
      }
    }
  }, [initialData, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onSave({ 
        english_name: englishName, 
        arabic_name: arabicName, 
        parent_id: parentId ? parseInt(parentId) : null
      });
      onClose(); // Close modal only after a successful save
    } catch (error) {
      console.error("Failed to save category:", error);
    }
  };

  if (!isOpen) return null;

  const flatCategories = flattenCategories(categories);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6">{initialData ? 'Edit Category' : 'Add New Category'}</h2>
        <form onSubmit={handleSubmit}>
          {/* ... Form inputs remain the same ... */}
           <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">English Name</label>
            <input type="text" value={englishName} onChange={(e) => setEnglishName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg" required />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">Arabic Name</label>
            <input type="text" value={arabicName} onChange={(e) => setArabicName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg" required />
          </div>
           <div className="mb-6">
            <label className="block text-gray-700 font-medium mb-2">Parent Category (Optional)</label>
            <select
              value={parentId}
              onChange={(e) => setParentId(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            >
              <option value="">-- No Parent (Top Level) --</option>
              {flatCategories.map(cat => (
                <option key={cat.id} value={cat.id} disabled={initialData && cat.id === initialData.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex justify-end gap-4">
            <button type="button" onClick={onClose} className="bg-gray-300 text-gray-800 font-bold py-2 px-6 rounded-lg hover:bg-gray-400">
              Cancel
            </button>
            <button type="submit" className="bg-blue-600 text-white font-bold py-2 px-6 rounded-lg hover:bg-blue-700">
              Save Category
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}